import Raven from 'raven-js';

import { APP_SITE_URL } from '../constants';
import { UNAUTHORIZED, CONFLICT } from '../constants/httpStatusCodes';

// Held in memory only, so other scripts on the page cannot read it. Login and logout reload the page,
// so it never outlives the session it came from.
let cachedToken = null;

let tokenRequestPromise = null;

// Set once /auth/token has not given us a token, so we use the cookie instead of asking again before
// every API call. Resets on page load.
let cookieAuthMode = false;

export async function getAccessToken() {
    if (cookieAuthMode) return null;

    if (cachedToken && Date.now() < cachedToken.expiry) return cachedToken.accessToken;

    if (tokenRequestPromise) return tokenRequestPromise;

    tokenRequestPromise = (async () => {
        try {
            const response = await fetch(`${APP_SITE_URL}/auth/token`, {
                credentials: `include`,
                headers: { Accept: `application/json` },
            });

            if (response.ok) {
                const { accessToken, expiresIn } = await response.json();
                if (accessToken) {
                    // Cache with 3-minute buffer before expiry
                    cachedToken = { accessToken, expiry: Date.now() + ((expiresIn - 180) * 1000) };
                    return accessToken;
                }
            } else if (response.status !== UNAUTHORIZED && response.status !== CONFLICT) {
                // 401 = not authenticated, 409 = FormsAuth user. Both mean use the cookie; anything else is a fault.
                Raven.captureMessage(`Could not get an access token`, { extra: { status: response.status } });
            }
        } catch (e) {
            Raven.captureException(e);
        } finally {
            tokenRequestPromise = null;
        }

        cookieAuthMode = true;
        return null;
    })();

    return tokenRequestPromise;
}

export function clearCachedToken() {
    cachedToken = null;
}



// WEBPACK FOOTER //
// ./scripts/services/authService.js